// Web stub for react-native-release-track. Provides `null` to allow react-native-web projects to compile.

export default null; 